import { Error as CommonError } from '@baseline/common'
import * as Sentry from '@sentry/react'

import { App } from './app'
import { Environment } from './app/environment'
import { Config } from './config'

const config = Config.load()
const ENV = Environment.fromStr(config.environment)
const INTERNAL_API_ORIGIN = config.internalApiOrigin

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      networkDetailAllowUrls: [`${INTERNAL_API_ORIGIN}/`],
      networkRequestHeaders: ['Content-Type'],
      networkResponseHeaders: ['Content-Type'],
    }),
  ],
  environment: ENV || 'local',
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  // tracesSampleRate sets a header which throws a CORS error when pointed at localhost api
  ...(ENV !== 'local' && { tracesSampleRate: 1.0 }),

  denyUrls: [/hubspot\.com/i, /google-analytics\.com/i, /hotjar\.com/i, /mixpanel\.com/i],

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0.1,

  // If the entire session is not sampled, use the below sample rate to sample
  // sessions when an error occurs.
  replaysOnErrorSampleRate: 1.0,
})

document.addEventListener('DOMContentLoaded', async () => {
  try {
    const app = new App()
    await app.start()
  } catch (error) {
    console.error(CommonError.getDump(error))
    throw error
  }
})
